import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { formValueSelector, registerField } from 'redux-form'
import flowRight from 'lodash/flowRight'
import includes from 'lodash/includes'
import find from 'lodash/find'
import { useSetState } from 'react-nb-hooks'
import { LKDate } from 'loankeeper-common/helpers/Date'
import transformProps from 'loankeeper-common/containers/transformProps'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'

import { Order } from '../../../WebAPI'
import { LKModalContainer, actions as LKModalActions } from '../../shared/LKModal'
import { getClientSelects, loadClientCashDocs, loadClientLinkedFiles } from '../../../store/client'
import { commonContainers, reduxFormContainer } from './addContainers'
import { FORM_NAME } from './constants'
import { getClientReqFields } from '../../../store/client'
import { accEntryViewBase, accEntryViewDetails, accEntryViewUCC } from 'src/store/accEntry'

const initialClientData = {
  loaded: false,
  idDocs: undefined,
  linkedFiles: undefined,
}

const withClientData = (Component) => (props) => {
  console.log(props)
  const dispatch = useDispatch()

  const [state, setState] = useSetState(initialClientData)

  const {
    name,
    OperTypeID,
    detailsTabData: { ClientID: clientId, HashSum_ClientID_: clientHash },
  } = props

  const fetchClientDetails = React.useCallback(async () => {
    const [clientCashDocsResult, clientLinkedFilesResult] = await Promise.all([
      dispatch(
        loadClientCashDocs({
          clientId,
          clientHash,
        }),
      ),
      dispatch(
        loadClientLinkedFiles({
          clientId,
          clientHash,
        }),
      ),
    ])

    const nextState = initialClientData

    if (loadClientCashDocs.fulfilled.match(clientCashDocsResult)) {
      nextState.idDocs = clientCashDocsResult.payload
    }

    if (loadClientLinkedFiles.fulfilled.match(clientLinkedFilesResult)) {
      nextState.linkedFiles = clientLinkedFilesResult.payload
    }

    setState({
      ...nextState,
      loaded: true,
    })
  }, [])

  React.useEffect(() => {
    if (
      ['OrderCashInCopy', 'OrderCashOutCopy', 'OrderCashOutEdit', 'OrderCashInEdit'].includes(name) &&
      [3, 4].includes(OperTypeID) &&
      clientId === 0
    ) {
      dispatch(LKModalActions.close(props.modalInstanceName))
      setState(initialClientData)
      return
    }

    fetchClientDetails()
  }, [fetchClientDetails, dispatch])

  return state.loaded && <Component {...props} iddocs={state.idDocs} linkedfiles={state.linkedFiles} />
}

const container = flowRight(
  LKModalContainer(),
  connect(undefined, (dispatch) => ({
    getClientReqFields: (params) => dispatch(getClientReqFields(params)),
    getClientSelects: (params) => dispatch(getClientSelects(params)),
    accEntryViewBase: (params) => dispatch(accEntryViewBase(params)),
    accEntryViewDetails: (params) => dispatch(accEntryViewDetails(params)),
    accEntryViewUCC: (params) => dispatch(accEntryViewUCC(params)),
  })),
  commonContainers,
  // withCallAPI({
  //   APICall: [Client.getSelects, Order.details, Order.details],
  //   APIParams: [
  //     undefined,
  //     (props) => ({ ID: props.params.ID, hash: props.params.hash, page: 'view', OperTypeID: props.cashOut ? 4 : 3 }),
  //     (props) => ({
  //       ID: props.params.ID,
  //       hash: props.params.hash,
  //       page: 'viewdetails',
  //       OperTypeID: props.cashOut ? 4 : 3,
  //     }),
  //   ],
  //   transformData: [
  //     (response) => ({ clientSelects: response.Data }),
  //     (response) => ({ mainTabData: response.Data, debitBalance: response.Data.BalanceDebit }),
  //     (response) => ({ detailsTabData: response.Data }),
  //   ],
  //   withLoading: true,
  // }),
  (Component) => {
    class WrappedUcc extends React.Component {
      constructor(props) {
        super(props)
        this.Wrapped = withCallAPI({
          APICall: [
            // Client.getSelects,
            //UPDATED API REQUEST client_lookups_api
            (params) => props.getClientSelects(params),
            //Order.details
            //UPDATED API REQUEST acc_entry_view_api page: 'view'
            (params) => props.accEntryViewBase(params),
            // (params) => Order.details(params),
            //UPDATED API REQUEST acc_entry_view_api page: 'viewdetails'
            (params) => props.accEntryViewDetails(params),
          ],
          APIParams: [
            undefined,
            (props) => ({
              EntryID: props.params.ID,
              HashSum_EntryID_: props.params.hash,
              page: 'view',
              OperTypeID: props.cashOut ? 4 : 3,
            }),
            (props) => ({
              EntryID: props.params.ID,
              HashSum_EntryID_: props.params.hash,
              page: 'viewdetails',
              OperTypeID: props.cashOut ? 4 : 3,
            }),
          ],
          transformData: [
            // (response) => ({ clientSelects: response.Data }),
            //UPDATED API REQUEST client_lookups_api
            ({ payload: response }) => ({ clientSelects: response }),
            // (response) => ({ mainTabData: response.Data, debitBalance: response.Data.BalanceDebit }),
            //UPDATED API REQUEST acc_entry_view_api page: 'view'
            ({ payload: response }) => ({ mainTabData: response, debitBalance: response.BalanceDebit }),
            //UPDATED API REQUEST acc_entry_view_api page: 'viewdetails'
            ({ payload: response }) => ({ detailsTabData: response }),
          ],
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedUcc
  },
  withClientData,
  // this alchemy is awesomely fucked up
  (Component) => {
    class WrappedUcc extends React.Component {
      constructor(props) {
        super(props)
        //mainTabData again
        // if (this.props.mainTabData && this.props.mainTabData.UCCEntry === 1) {
        if (this.props.mainTabData && this.props.mainTabData.UCCEntry === 1) {
          this.Wrapped = withCallAPI({
            APICall: [
              (params) => {
                //needs checking
                //UPDATED API REQUEST acc_entry_view_api page: 'viewucc'
                props.accEntryViewUCC(params)
                return Order.details(params)
              },
            ],
            // APICall: [],
            APIParams: [
              (p) => ({
                ID: p.params.ID,
                hash: p.params.hash,
                page: 'viewucc',
                OID: p.mainTabData.OID,
                HashSum_OID_: p.mainTabData.HashSum_OID_,
              }),
            ],
            transformData: [(response) => ({ uccViewData: response.Data })],
            withLoading: true,
          })(Component)
        } else {
          this.Wrapped = Component
        }
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedUcc
  },

  (Component) => {
    const WrappedReqFields = (props) => {
      const { name, OperTypeID, detailsTabData } = props

      const NewComp = React.useMemo(() => {
        if (
          includes(['OrderCashOutEdit', 'OrderCashInEdit'], name) &&
          includes([3, 4], OperTypeID) &&
          detailsTabData.ClientID === 0
        ) {
          return <Component {...props} />
        }

        const { ClientType } = detailsTabData

        const Wrapper = withCallAPI({
          // APICall: [Client.getRequiredFields],
          //UPDATED API REQUEST client_reqfields_api
          APICall: [(params) => props.getClientReqFields(params)],
          APIParams: [() => ({ groupid: 9, typeid: ClientType })],
          transformData: [
            // (response) => ({
            //UPDATED API REQUEST client_reqfields_api
            ({ payload: response }) => ({
              requiredFields: response.ReqFields.reduce(
                (result, current) => ({
                  ...result,
                  [current.FName]: current,
                }),
                {},
              ),
            }),
          ],
          withLoading: true,
        })(Component)

        return <Wrapper {...props} />

        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [name, OperTypeID, detailsTabData.ClientID])

      return NewComp
    }

    return WrappedReqFields
  },

  transformProps((props) => ({
    ...props,
    initialValues: {
      action: props.copyOrder ? 'add' : 'edit',
      IDDoc:
        props.iddocs &&
        (find(props.iddocs, (d) => d.IDNumber === props.detailsTabData.OtherIDNumber) ||
          find(props.iddocs, (d) => d.DFDoc === 1)),
      LinkedFiles: props.linkedfiles,
      OperTypeID: props.cashOut ? 4 : 3,
      chosenAccountTypeID: props.cashOut ? props.mainTabData.DebitAccTypeID : props.mainTabData.CreditAccTypeID,
      EntryID: props.copyOrder ? undefined : props.mainTabData.ID,
      HashSum_EntryID_: props.copyOrder ? undefined : props.mainTabData.HashSum_EntryID_,
      DocNo: props.copyOrder ? '' : props.mainTabData.DocNo,
      CCY: props.mainTabData.CCY,
      DocDate: props.copyOrder ? props.OpenDay : LKDate.from(props.mainTabData.DocDate).toString(),
      DebitAccNo: props.mainTabData.DebitAcc,
      DebitChosenAccNo: props.mainTabData.DebitAcc,
      DebitAccID: props.mainTabData.DebitAccID,
      DebitAccHash: props.mainTabData.HashSum_DebitAccID_,
      DebitTitleUNI: props.mainTabData.DebitAccTitleUNI,
      DebitAccBalance: props.mainTabData.BalanceDebit,
      CreditAccNo: props.mainTabData.CreditAcc,
      CreditChosenAccNo: props.mainTabData.CreditAcc,
      CreditAccID: props.mainTabData.CreditAccID,
      CreditAccHash: props.mainTabData.HashSum_CreditAccID_,
      CreditTitleUNI: props.mainTabData.CreditAccTitleUNI,
      CreditAccBalance: props.mainTabData.BalanceCredit,
      Amount: props.copyOrder ? 0 : props.mainTabData.Amount,
      OpCodeID: props.mainTabData.OpCodeID,
      Comment: props.mainTabData.Comment,
      clientID: props.detailsTabData.ClientID,
      clientHash: props.detailsTabData.HashSum_ClientID_,
      clientIsChosen: !!props.detailsTabData.ClientID,
      clientType: props.detailsTabData.ClientType,
      ClientType: props.detailsTabData.ClientType.toString(),
      Name: props.detailsTabData.Name,
      Surname: props.detailsTabData.Surname,
      Name_ALT: props.detailsTabData.Name_ALT,
      Surname_ALT: props.detailsTabData.Surname_ALT,
      CityID: props.detailsTabData.CityID,
      Address: props.detailsTabData.Address,
      DOB: props.detailsTabData.DOB === '1900-01-01 00:00:00' ? '' : LKDate.from(props.detailsTabData.DOB).toString(),
      DOBCheck: '0',
      CellPhone: props.detailsTabData.CellPhone,
      IDCardTypeID: props.detailsTabData.IDCardTypeID,
      CardNumber: props.detailsTabData.CardNumber,
      CardNumberSearch: '',
      OtherIDNumber: props.detailsTabData.OtherIDNumber,
      IDCardIssuerID: props.detailsTabData.IDCardIssuerID,
      IDCardRegDate:
        props.detailsTabData.IDCardRegDate === '1900-01-01 00:00:00'
          ? ''
          : LKDate.from(props.detailsTabData.IDCardRegDate).toString(),
      IDCardRegDateCheck: '1',
      IDValidityDate:
        props.detailsTabData.IDValidityDate === '1900-01-01 00:00:00'
          ? ''
          : LKDate.from(props.detailsTabData.IDValidityDate).toString(),
      IDValidityDateCheck: '1',
      AddUserInDB: '0',
      CitizenshipID: props.detailsTabData.CitizenshipID,

      MoneyTransferAgent: props.detailsTabData.MoneyTransferAgent,
      MoneyTransferSystemID: props.detailsTabData.MoneyTransferSystemID,
      MoneyTransferCountryID: props.detailsTabData.MoneyTransferCountryID,
      moneytransfer_code: props.detailsTabData.MoneyTransferCode,
      moneytransfer_agent: props.detailsTabData.MTA_FullName,
      moneytransfer_address: props.detailsTabData.MTA_Address,
      moneytransfer_bdate: props.detailsTabData.MTA_DOB,
      moneytransfer_bplace: props.detailsTabData.MTA_BirthPlace,
      moneytransfer_doc: props.detailsTabData.MTA_DocNo,
    },
  })),

  connect(
    (state) => ({
      clientWatched: formValueSelector(FORM_NAME)(state, 'clientWatched'),
    }),

    {
      openModal: LKModalActions.open,
      closeModalAction: LKModalActions.close,
      register: registerField,
      openError: LKModalActions.openError,
    },
  ),
  reduxFormContainer,
)

export default container
